import { render, staticRenderFns } from "./EstablishmentDetails.vue?vue&type=template&id=592b1057&scoped=true"
import script from "./EstablishmentDetails.vue?vue&type=script&lang=js"
export * from "./EstablishmentDetails.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentDetails.vue?vue&type=style&index=0&id=592b1057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592b1057",
  null
  
)

export default component.exports